import { createContext, useContext } from 'react';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastApi {
  /** Legacy `toasterService.pop(type, title, body)`. */
  pop: (type: ToastType, title: string, body?: string) => void;
  success: (title: string, body?: string) => void;
  error: (title: string, body?: string) => void;
  info: (title: string, body?: string) => void;
  warning: (title: string, body?: string) => void;
}

/** As angular2-toaster's default. */
export const TOAST_TIMEOUT_MS = 5000;

export const ToastContext = createContext<ToastApi | null>(null);

export function useToast(): ToastApi {
  const api = useContext(ToastContext);
  if (!api) {
    throw new Error('useToast() needs a <ToastProvider> above it');
  }
  return api;
}
